export default __webpack_public_path__ + "1687f22865495c624a852545e8f9f8b4.png";